import React, { forwardRef, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import CreateableSelect from 'react-select/creatable';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import { debounce } from '../../helpers';

const styles = theme => ({});
const useStyles = makeStyles(styles);

const defaultControlStyles = {
  error: {
    borderColor: 'red',
    borderWidth: 2,
  },
};

export const Autocomplete = forwardRef((props, ref) => {
  const classes = useStyles(styles);

  const {
    value,
    onChange,
    options,
    label,
    placeholder,
    disabled,
    isLoading,
    loading,
    error,
    isMulti,
    isClearable,
    hideLabel,
    createable,
    onCreateOption,
    async,
    loadOptions,
    defaultOptions,
    debounceMs,
    styleOptions,
    controlStyles,
    containerStyles,
    extraProps,
    maxHeight,
    isAbsolute,
    ...rest
  } = props;

  const debouncedLoadOptions = useMemo(() => debounce(loadOptions, debounceMs), [
    loadOptions,
    debounceMs,
  ]);

  const selectProps = {
    ref,
    value,
    onChange,
    placeholder,
    options,
    isClearable,
    isLoading: isLoading || loading,
    isDisabled: disabled,
    isMulti,
          styles: {
        control: style => [
          { ...style },
          error && defaultControlStyles.error,
          {
            minWidth: 100,
            minHeight: 49 /* matching text & date input heights */,
            border: '1px solid #aaa',
            ...controlStyles,
          },
        ],
        valueContainer: style => [
          { ...style },
          error && defaultControlStyles.error,
          {
            maxHeight: maxHeight,
            overflow: 'auto',
            ...controlStyles,
          },
        ],
        menu: style => ({
          ...style,
          position: 'absolute',
          zIndex: 1000,
        }),
        menuPortal: style => ({
          ...style,
          zIndex: 1000,
        }),
        ...styleOptions,
      },
      ...(isAbsolute && { menuPortalTarget: document.body }),
    onCreateOption,
    loadOptions: debouncedLoadOptions,
    defaultOptions,
    ...extraProps,
    ...rest,
  };

  return (
    <div style={{ width: '100%', ...containerStyles }}>
      <div>
        {/* {!hideLabel && label} */}
        {/* {isLoading && <CircularProgress style={{ fill: '#aaa', color: '#000' }} size={16} />} */}
      </div>

      {/* {!createable && <Select {...selectProps} />}
      {createable && <CreateableSelect {...selectProps} />} */}

      {createable ? (
        <CreateableSelect {...selectProps} />
      ) : async ? (
        <AsyncSelect {...selectProps} />
      ) : (
        <Select {...selectProps} />
      )}
    </div>
  );
});

Autocomplete.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  error: PropTypes.bool,
  isMulti: PropTypes.bool,
  hideLabel: PropTypes.bool,
  createable: PropTypes.bool,
  onCreateOption: PropTypes.func,
  styleOptions: PropTypes.object,
  controlStyles: PropTypes.object,
  containerStyles: PropTypes.object,
  extraProps: PropTypes.object,
  debounceMs: PropTypes.number,
  defaultOptions: PropTypes.bool,
  isAbsolute: PropTypes.bool,
};

Autocomplete.defaultProps = {
  // options: defaultOpts,
  error: false,
  isMulti: false,
  hideLabel: false,
  createable: false,
  styleOptions: {},
  controlStyles: {},
  containerStyle: {},
  extraProps: {},
  debounceMs: 500,
  defaultOptions: true,
  isAbsolute: false,
};
